import { type ReduxStateShared } from '~shared/types';

export const getAppTime = (state: ReduxStateShared) => state.appTime;
